import * as React from 'react'
import styled from 'styled-components'
import * as plume from '@ulule/owl-kit-components/next'
const SimpleModalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const SimpleModalContent = styled(plume.Modal)`
  ${plume.styles.heading.XXS} {
    margin-bottom: 20px;
  }
`

type SimpleModalProps = {
  buttons?: plume.ModalButtons
  children: React.ReactNode
  className?: string
  closable: boolean
  onClose: () => void
  open: boolean
}

function SimpleModalComponent({
  buttons,
  children,
  className,
  closable,
  onClose,
  open,
}: SimpleModalProps): React.ReactElement<SimpleModalProps> {
  return (
    <SimpleModalWrapper className={className}>
      <SimpleModalContent open={open} closable={closable} onClose={onClose} buttons={buttons}>
        {children}
      </SimpleModalContent>
    </SimpleModalWrapper>
  )
}

export const SimpleModal = styled(SimpleModalComponent)<SimpleModalProps>``
